import MixpanelWebSDK from './MixpanelWebSDK'

export default MixpanelWebSDK
